<div *ngIf="formattedValue" >
    <!-- {{ params.value &nbsp; | currency:currencyCode:'symbol' }} -->
    <span [title]="priceTooltip">{{ numericValue &nbsp; }}</span>
</div>

<div *ngIf="!formattedValue && params.colDef.field == 'casePrice'">
    {{ params.value}}
</div>